
    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/agent00/work/ad4ac254fb89a706/spotify-ooi/src/components/Spotify/Widget/index.tsx';
    import createController from '/home/builduser/agent00/work/ad4ac254fb89a706/spotify-ooi/src/components/Spotify/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    

    var createErrorMonitor = null;
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

var BaseUiEnvironmentProviderWrapper = React.Fragment;

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/agent00/work/ad4ac254fb89a706/spotify-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'Spotify';
    var projectName = 'spotify-ooi';
    var sentryConfig = {
      DSN: 'https://01fb0c955b864231aa35321b27af56a8@sentry.wixpress.com/440',
      id: '01fb0c955b864231aa35321b27af56a8',
      projectName: 'spotify',
      teamName: 'music',
      
    };
    var stylesParams = null;
    var experimentsConfig = {"scopes":["spotify"]};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/agent00/work/ad4ac254fb89a706/spotify-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hu","id","it","ja","ko","lt","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"searcher.album":"Albums","searcher.song":"Tracks","searcher.playlist":"Playlists","searcher.artist":"Artists","searcher.select":"Select","searcher.cancel":"Cancel","search.start.searchHeader":"Search for albums, tracks, playlists or artists","settings.tabs.main":"Main","settings.tabs.settings":"Settings","settings.main.loginInfo":"Spotify log-in is required","settings.main.loginButton":"Log-in","settings.main.searchSpotifyButton":"Search Spotify","settings.main.intro":"Stream your favorite music from Spotify directly on your website. Search albums, tracks, playlists or artists.","settings.settings.spotifyUriTitle":"Spotify URI","settings.settings.spotifyUriPlaceholder":"Paste it here","settings.settings.loginButton":"Log-in","settings.settings.updateButton":"Update","settings.settings.popupInfo":"To find a Spotify URI: enter the Spotify desktop app > click the 3 dots on your track, album or playlist > click Share > and select Copy Spotify URI.","settings.settings.popupError":"Check the Spotify URI and try again","settings.settings.search":"Search Spotify","settings.settings.changeMusic":"Change Music","settings.settings.spotifyTitle":"Search Spotify","search.error.title":"Something went wrong","search.error.description":"Please try again later.","search.noResults.track":"No results found in Tracks","search.noResults.album":"No results found in Albums","search.noResults.artist":"No results found in Artists","search.noResults.playlist":"No results found in Playlists","search.noResults.tryDifferent":"Try searching again using a different spelling or keyword.","search.tableView.number":"NO.","search.tableView.track":"TRACK NAME","search.tableView.artist":"ARTIST NAME","search.tableView.album":"ALBUM","search.textInput.placeholder":"Search","search.textInput.xTitle":"Search","search.textInput.inputTitle":"Type what you want to find then press Enter"};
    var biConfig = null;
    var appDefinitionId = "099ac204-be88-4ed1-89af-cf14358c83f1";
    var componentId = "53d0a5fa-3da5-418b-84d6-e58bd55fecad";
    var localeDistPath = 'assets/locales';
    var shouldUseEssentials = false;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/agent00/work/ad4ac254fb89a706/spotify-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
